module.exports = __webpack_public_path__ + "static/img/icon_star_superRare@2x.b546b22a.png";